import { defineComponent as _defineComponent } from 'vue';
import { Check, Minus } from 'lucide-vue-next';
import { reactiveOmit } from '@vueuse/core';
import { CheckboxRoot, useForwardPropsEmits } from 'reka-ui';
import { cn } from '../utils';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Checkbox',
    props: {
        defaultValue: { type: null, required: false },
        modelValue: { type: null, required: false },
        disabled: { type: Boolean, required: false },
        value: { type: null, required: false },
        id: { type: String, required: false },
        trueValue: { type: null, required: false },
        falseValue: { type: null, required: false },
        asChild: { type: Boolean, required: false },
        as: { type: null, required: false },
        name: { type: String, required: false },
        required: { type: Boolean, required: false },
        class: { type: [Boolean, null, String, Object, Array], required: false, skipCheck: true }
    },
    emits: ["update:modelValue"],
    setup(__props, { expose: __expose, emit: __emit }) {
        __expose();
        const props = __props;
        const emits = __emit;
        const delegatedProps = reactiveOmit(props, 'class');
        const forwarded = useForwardPropsEmits(delegatedProps, emits);
        const __returned__ = { props, emits, delegatedProps, forwarded, get Check() { return Check; }, get Minus() { return Minus; }, get CheckboxRoot() { return CheckboxRoot; }, get cn() { return cn; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
